<div class="note-main-container">
  <div class="row">
    <div class="col-md-6">
      <div class="cm-display">
        <div class="cm-heading">
          <div class="cm-heading-text">
            <svg
              class="svg-icon"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.37293 12.472C8.1863 12.472 8.03111 12.5346 7.90736 12.6599C7.78361 12.7851 7.72173 12.9406 7.72173 13.1263V16.8323C7.72173 17.018 7.78466 17.1735 7.91051 17.2988C8.03638 17.424 8.19263 17.4866 8.37926 17.4866C8.56589 17.4866 8.72108 17.424 8.84483 17.2988C8.96858 17.1735 9.03046 17.018 9.03046 16.8323V13.1263C9.03046 12.9406 8.96752 12.7851 8.84166 12.6599C8.7158 12.5346 8.55956 12.472 8.37293 12.472ZM16.6208 7.07668C16.4341 7.07668 16.2789 7.1393 16.1552 7.26455C16.0314 7.38981 15.9696 7.5453 15.9696 7.73103V16.8323C15.9696 17.018 16.0325 17.1735 16.1584 17.2988C16.2842 17.424 16.4405 17.4866 16.6271 17.4866C16.8137 17.4866 16.9689 17.424 17.0927 17.2988C17.2164 17.1735 17.2783 17.018 17.2783 16.8323V7.73103C17.2783 7.5453 17.2154 7.38981 17.0895 7.26455C16.9637 7.1393 16.8074 7.07668 16.6208 7.07668ZM12.4969 14.6435C12.3102 14.6435 12.155 14.7072 12.0313 14.8346C11.9075 14.962 11.8457 15.1164 11.8457 15.2978V16.8323C11.8457 17.018 11.9086 17.1735 12.0344 17.2988C12.1603 17.424 12.3165 17.4866 12.5032 17.4866C12.6898 17.4866 12.845 17.424 12.9687 17.2988C13.0925 17.1735 13.1544 17.018 13.1544 16.8323V15.2978C13.1544 15.1164 13.0914 14.962 12.9656 14.8346C12.8397 14.7072 12.6835 14.6435 12.4969 14.6435ZM5.27514 21.3542C4.82744 21.3542 4.44396 21.1945 4.12473 20.8753C3.80549 20.5561 3.64587 20.1726 3.64587 19.7249V5.27515C3.64587 4.82744 3.80549 4.44396 4.12473 4.12473C4.44396 3.80549 4.82744 3.64587 5.27514 3.64587H19.7249C20.1726 3.64587 20.5561 3.80549 20.8753 4.12473C21.1945 4.44396 21.3542 4.82744 21.3542 5.27515V19.7249C21.3542 20.1726 21.1945 20.5561 20.8753 20.8753C20.5561 21.1945 20.1726 21.3542 19.7249 21.3542H5.27514ZM5.27514 20.0454H19.7249C19.805 20.0454 19.8785 20.012 19.9452 19.9452C20.012 19.8785 20.0454 19.805 20.0454 19.7249V5.27515C20.0454 5.19501 20.012 5.12155 19.9452 5.05478C19.8785 4.98799 19.805 4.9546 19.7249 4.9546H5.27514C5.19501 4.9546 5.12155 4.98799 5.05478 5.05478C4.98799 5.12155 4.9546 5.19501 4.9546 5.27515V19.7249C4.9546 19.805 4.98799 19.8785 5.05478 19.9452C5.12155 20.012 5.19501 20.0454 5.27514 20.0454ZM12.5032 12.2115C12.6898 12.2115 12.845 12.1486 12.9687 12.0227C13.0925 11.8969 13.1544 11.7406 13.1544 11.554C13.1544 11.3674 13.0914 11.2122 12.9656 11.0884C12.8397 10.9647 12.6835 10.9028 12.4969 10.9028C12.3102 10.9028 12.155 10.9657 12.0313 11.0916C11.9075 11.2175 11.8457 11.3737 11.8457 11.5603C11.8457 11.747 11.9086 11.9022 12.0344 12.0259C12.1603 12.1497 12.3165 12.2115 12.5032 12.2115Z"
                fill="#3D3D3D"
              />
            </svg>
            <span>Career Manager Notes</span>
          </div>
        </div>
        <div class="cm-notes">
          <div *ngIf="allCmMeetingNotesList.length == 0">
            <app-empty-notes></app-empty-notes>
          </div>
          <div class="notes-container">
            <div
              class="single-note-detail-container"
              *ngFor="let note of allCmMeetingNotesList"
            >
              <div class="single-note-detail">
                <div class="note-date">
                  {{ note.date | date : "dd/MM/yyyy" }}
                </div>
                <div class="note-title">
                  {{ note.noteTitle }}
                </div>
              </div>
              <div
                class="three-dots-container"
                [matMenuTriggerFor]="beforeMenu"
              >
                <img src="assets/icons/3dots.png" class="threedots" />
                <mat-menu
                  class="matmenu"
                  #beforeMenu="matMenu"
                  xPosition="before"
                >
                  <button
                    mat-menu-item
                    class="first"
                    (click)="openAssignNotesDialogue('view', note)"
                  >
                    <span class="connect">View</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="openAssignNotesDialogue('edit', note)"
                  >
                    <span class="bold">Edit</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="openDeleteConfirmationDialog(note.id)"
                  >
                    <span class="bold">Delete</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="other-cm-display">
        <!-- cap-leads notes -->
        <div
          [ngClass]="!shouldShowPntNotes ? 'cm-display' : 'other-cm-component'"
        >
          <div class="other-cm-heading">
            <div class="other-cm-heading-text">
              <svg
                class="svg-icon"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.37293 12.472C8.1863 12.472 8.03111 12.5346 7.90736 12.6599C7.78361 12.7851 7.72173 12.9406 7.72173 13.1263V16.8323C7.72173 17.018 7.78466 17.1735 7.91051 17.2988C8.03638 17.424 8.19263 17.4866 8.37926 17.4866C8.56589 17.4866 8.72108 17.424 8.84483 17.2988C8.96858 17.1735 9.03046 17.018 9.03046 16.8323V13.1263C9.03046 12.9406 8.96752 12.7851 8.84166 12.6599C8.7158 12.5346 8.55956 12.472 8.37293 12.472ZM16.6208 7.07668C16.4341 7.07668 16.2789 7.1393 16.1552 7.26455C16.0314 7.38981 15.9696 7.5453 15.9696 7.73103V16.8323C15.9696 17.018 16.0325 17.1735 16.1584 17.2988C16.2842 17.424 16.4405 17.4866 16.6271 17.4866C16.8137 17.4866 16.9689 17.424 17.0927 17.2988C17.2164 17.1735 17.2783 17.018 17.2783 16.8323V7.73103C17.2783 7.5453 17.2154 7.38981 17.0895 7.26455C16.9637 7.1393 16.8074 7.07668 16.6208 7.07668ZM12.4969 14.6435C12.3102 14.6435 12.155 14.7072 12.0313 14.8346C11.9075 14.962 11.8457 15.1164 11.8457 15.2978V16.8323C11.8457 17.018 11.9086 17.1735 12.0344 17.2988C12.1603 17.424 12.3165 17.4866 12.5032 17.4866C12.6898 17.4866 12.845 17.424 12.9687 17.2988C13.0925 17.1735 13.1544 17.018 13.1544 16.8323V15.2978C13.1544 15.1164 13.0914 14.962 12.9656 14.8346C12.8397 14.7072 12.6835 14.6435 12.4969 14.6435ZM5.27514 21.3542C4.82744 21.3542 4.44396 21.1945 4.12473 20.8753C3.80549 20.5561 3.64587 20.1726 3.64587 19.7249V5.27515C3.64587 4.82744 3.80549 4.44396 4.12473 4.12473C4.44396 3.80549 4.82744 3.64587 5.27514 3.64587H19.7249C20.1726 3.64587 20.5561 3.80549 20.8753 4.12473C21.1945 4.44396 21.3542 4.82744 21.3542 5.27515V19.7249C21.3542 20.1726 21.1945 20.5561 20.8753 20.8753C20.5561 21.1945 20.1726 21.3542 19.7249 21.3542H5.27514ZM5.27514 20.0454H19.7249C19.805 20.0454 19.8785 20.012 19.9452 19.9452C20.012 19.8785 20.0454 19.805 20.0454 19.7249V5.27515C20.0454 5.19501 20.012 5.12155 19.9452 5.05478C19.8785 4.98799 19.805 4.9546 19.7249 4.9546H5.27514C5.19501 4.9546 5.12155 4.98799 5.05478 5.05478C4.98799 5.12155 4.9546 5.19501 4.9546 5.27515V19.7249C4.9546 19.805 4.98799 19.8785 5.05478 19.9452C5.12155 20.012 5.19501 20.0454 5.27514 20.0454ZM12.5032 12.2115C12.6898 12.2115 12.845 12.1486 12.9687 12.0227C13.0925 11.8969 13.1544 11.7406 13.1544 11.554C13.1544 11.3674 13.0914 11.2122 12.9656 11.0884C12.8397 10.9647 12.6835 10.9028 12.4969 10.9028C12.3102 10.9028 12.155 10.9657 12.0313 11.0916C11.9075 11.2175 11.8457 11.3737 11.8457 11.5603C11.8457 11.747 11.9086 11.9022 12.0344 12.0259C12.1603 12.1497 12.3165 12.2115 12.5032 12.2115Z"
                  fill="#3D3D3D"
                />
              </svg>
              <span>Capability Lead Notes</span>
            </div>
          </div>
          <div [ngClass]="!shouldShowPntNotes ? 'cm-notes' : 'other-cm-notes'">
            <div *ngIf="allCapLeadMeetingNotesList.length == 0">
              <app-empty-notes></app-empty-notes>
            </div>
            <div class="notes-container">
              <div
                class="single-note-detail-container"
                *ngFor="let note of allCapLeadMeetingNotesList"
              >
                <div class="single-note-detail">
                  <div class="note-date">
                    {{ note.date | date : "dd/MM/yyyy" }}
                  </div>
                  <div class="note-title">{{ note.noteTitle }}</div>
                </div>
                <div
                  class="three-dots-container"
                  [matMenuTriggerFor]="beforeMenu"
                >
                  <img src="assets/icons/3dots.png" class="threedots" />
                  <mat-menu
                    class="matmenu"
                    #beforeMenu="matMenu"
                    xPosition="before"
                  >
                    <button
                      mat-menu-item
                      class="first"
                      (click)="openAssignNotesDialogue('view', note)"
                    >
                      <span class="connect">View</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="openAssignNotesDialogue('edit', note)"
                    >
                      <span class="bold">Edit</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="openDeleteConfirmationDialog(note.id)"
                    >
                      <span class="bold">Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- PnT notes -->
        <div *ngIf="shouldShowPntNotes" class="other-cm-component">
          <div class="other-cm-heading">
            <div class="other-cm-heading-text">
              <svg
                class="svg-icon"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.37293 12.472C8.1863 12.472 8.03111 12.5346 7.90736 12.6599C7.78361 12.7851 7.72173 12.9406 7.72173 13.1263V16.8323C7.72173 17.018 7.78466 17.1735 7.91051 17.2988C8.03638 17.424 8.19263 17.4866 8.37926 17.4866C8.56589 17.4866 8.72108 17.424 8.84483 17.2988C8.96858 17.1735 9.03046 17.018 9.03046 16.8323V13.1263C9.03046 12.9406 8.96752 12.7851 8.84166 12.6599C8.7158 12.5346 8.55956 12.472 8.37293 12.472ZM16.6208 7.07668C16.4341 7.07668 16.2789 7.1393 16.1552 7.26455C16.0314 7.38981 15.9696 7.5453 15.9696 7.73103V16.8323C15.9696 17.018 16.0325 17.1735 16.1584 17.2988C16.2842 17.424 16.4405 17.4866 16.6271 17.4866C16.8137 17.4866 16.9689 17.424 17.0927 17.2988C17.2164 17.1735 17.2783 17.018 17.2783 16.8323V7.73103C17.2783 7.5453 17.2154 7.38981 17.0895 7.26455C16.9637 7.1393 16.8074 7.07668 16.6208 7.07668ZM12.4969 14.6435C12.3102 14.6435 12.155 14.7072 12.0313 14.8346C11.9075 14.962 11.8457 15.1164 11.8457 15.2978V16.8323C11.8457 17.018 11.9086 17.1735 12.0344 17.2988C12.1603 17.424 12.3165 17.4866 12.5032 17.4866C12.6898 17.4866 12.845 17.424 12.9687 17.2988C13.0925 17.1735 13.1544 17.018 13.1544 16.8323V15.2978C13.1544 15.1164 13.0914 14.962 12.9656 14.8346C12.8397 14.7072 12.6835 14.6435 12.4969 14.6435ZM5.27514 21.3542C4.82744 21.3542 4.44396 21.1945 4.12473 20.8753C3.80549 20.5561 3.64587 20.1726 3.64587 19.7249V5.27515C3.64587 4.82744 3.80549 4.44396 4.12473 4.12473C4.44396 3.80549 4.82744 3.64587 5.27514 3.64587H19.7249C20.1726 3.64587 20.5561 3.80549 20.8753 4.12473C21.1945 4.44396 21.3542 4.82744 21.3542 5.27515V19.7249C21.3542 20.1726 21.1945 20.5561 20.8753 20.8753C20.5561 21.1945 20.1726 21.3542 19.7249 21.3542H5.27514ZM5.27514 20.0454H19.7249C19.805 20.0454 19.8785 20.012 19.9452 19.9452C20.012 19.8785 20.0454 19.805 20.0454 19.7249V5.27515C20.0454 5.19501 20.012 5.12155 19.9452 5.05478C19.8785 4.98799 19.805 4.9546 19.7249 4.9546H5.27514C5.19501 4.9546 5.12155 4.98799 5.05478 5.05478C4.98799 5.12155 4.9546 5.19501 4.9546 5.27515V19.7249C4.9546 19.805 4.98799 19.8785 5.05478 19.9452C5.12155 20.012 5.19501 20.0454 5.27514 20.0454ZM12.5032 12.2115C12.6898 12.2115 12.845 12.1486 12.9687 12.0227C13.0925 11.8969 13.1544 11.7406 13.1544 11.554C13.1544 11.3674 13.0914 11.2122 12.9656 11.0884C12.8397 10.9647 12.6835 10.9028 12.4969 10.9028C12.3102 10.9028 12.155 10.9657 12.0313 11.0916C11.9075 11.2175 11.8457 11.3737 11.8457 11.5603C11.8457 11.747 11.9086 11.9022 12.0344 12.0259C12.1603 12.1497 12.3165 12.2115 12.5032 12.2115Z"
                  fill="#3D3D3D"
                />
              </svg>
              <span> PnT Buddy Notes</span>
            </div>
          </div>
          <div class="other-cm-notes">
            <div *ngIf="allPntMeetingNotesList.length == 0">
              <app-empty-notes></app-empty-notes>
            </div>
            <div class="notes-container">
              <div
                class="single-note-detail-container"
                *ngFor="let note of allPntMeetingNotesList"
              >
                <div class="single-note-detail">
                  <div class="note-date">
                    {{ note.date | date : "dd/MM/yyyy" }}
                  </div>
                  <div class="note-title">{{ note.noteTitle }}</div>
                </div>
                <div
                  class="three-dots-container"
                  [matMenuTriggerFor]="beforeMenu"
                >
                  <img src="assets/icons/3dots.png" class="threedots" />
                  <mat-menu
                    class="matmenu"
                    #beforeMenu="matMenu"
                    xPosition="before"
                  >
                    <button
                      mat-menu-item
                      class="first"
                      (click)="openAssignNotesDialogue('view', note)"
                    >
                      <span class="connect">View</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="openAssignNotesDialogue('edit', note)"
                    >
                      <span class="bold">Edit</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="openDeleteConfirmationDialog(note.id)"
                    >
                      <span class="bold">Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
